import { Injectable, inject } from '@angular/core'
import { RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Facility } from './facility'
import { BehaviorSubject, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'
import { LoggerFactory } from '@elderbyte/ts-logger'

@Injectable({
  providedIn: 'root',
})
export class FacilityService extends RestClientList<Facility, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private readonly _activeFacility$ = new BehaviorSubject<Facility>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/facilities', http)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public get activeFacility$(): Observable<Facility> {
    return this._activeFacility$.pipe(filter((facility) => !!facility))
  }

  public get activeFacilitySnapshot(): Facility {
    return this._activeFacility$.getValue()
  }

  public setActiveFacility(facility: Facility): void {
    if (this.activeFacilitySnapshot?.id !== facility?.id) {
      this.log.info('Setting active facility:', facility)
      this._activeFacility$.next(facility)
    }
  }

  public setActiveFacilityId(facility: string): void {
    this.findById(facility).subscribe((facility) => this.setActiveFacility(facility))
  }
}
